// src/components/NotFound/NotFound.js
import React from 'react';
import { Container, Heading } from '../../styled/common';

const NotFound = () => (
  <Container>
    <Heading>404 - Page Not Found</Heading>
    <p>The page you are looking for does not exist.</p>
  </Container>
);

export default NotFound;
